import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/workFlowEntity';

//workFlowActivities
function createWorkFlowActivities(state, action) {
  state.activities.workFlowActivities = action.payload.data ? action.payload.data : [];
}

function connectionWorkFlowActivities(state, action) {
  state.activities.connection = action.payload.connection;
}

function errorWorkFlowActivities(state, action) {
  state.activities.error = action.payload.error ? action.payload.error : false;
  state.activities.message = action.payload.message ? action.payload.message : "";
}

//workFlowStates
function createWorkFlowSatates(state, action) {
  state.states.workFlowStates = action.payload.data ? action.payload.data : [];
}

function connectionWorkFlowSatates(state, action) {
  state.states.connection = action.payload.connection;
}

function errorWorkFlowSatates(state, action) {
  state.states.error = action.payload.error ? action.payload.error : false;
  state.states.message = action.payload.message ? action.payload.message : "";
}

const workFlowReducer = createSlice({
  name: 'workFlow',
  initialState: initState,
  reducers: {
    //workFlowActivities
    createWorkFlowActivities,
    connectionWorkFlowActivities,
    errorWorkFlowActivities,
    //workFlowStates
    createWorkFlowSatates,
    connectionWorkFlowSatates,
    errorWorkFlowSatates
  },
});

export const workFlowActions = {
  ...workFlowReducer.actions,
};

export default workFlowReducer.reducer;
